import { settings } from '@pixi/settings';

/**
 * Default `canvasPadding` for canvas-based Mesh rendering.
 * @see PIXI.Mesh2d#canvasPadding
 * @static
 * @memberof PIXI.settings
 * @member {number}
 * @default 0
 */
settings.MESH_CANVAS_PADDING = 0;

export { settings };
